<template>
  <div ref="toastN">
    <div class='toastN' v-if="show">{{ info }}</div>
  </div>
</template>

<script>
export default {
  name: 'toast',
  props: { },
  data(){
    return{
      show:false,
      info:""
    }
  },
methods:{
  showToast(info){
    this.show = true
    this.info = info
    setTimeout(() => {
      this.show =false
    }, 3000);
  }
},
}
</script>
<style scoped lang="scss">


</style>